import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/offer';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById('hero-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <AnimatePresence data-id="element-128" data-mp="bpr931fdpff4">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2" data-id="element-129" data-mp="boycgta4w6ap">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2.5 rounded-2xl bg-cta-600 px-4 py-4 font-display text-[20px] font-extrabold uppercase tracking-wide text-white shadow-[0_8px_24px_rgba(5,11,24,0.45)] ring-2 ring-white/80 focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400" data-id="element-130" data-mp="2b4ju5gyt9ykh">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" strokeWidth={2.5} aria-hidden="true" data-id="element-131" data-mp="1rgkkk9fzgxgn" />
            <span className="whitespace-nowrap" data-id="element-132" data-mp="1wbgcl9l7zktr">Get it now for only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}